import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import URLS from 'redux/urls'
import request from 'redux/utils/request'

export const fetchAllDapil = createAsyncThunk(
    'Dapil/fetchAllDapil',
    async (_, { rejectWithValue }) => {
        try {
            const response = await request('get', URLS.DAPIL)
            return response.data.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const fetchAllDapilQuery = createAsyncThunk(
    'Dapil/fetchAllDapil',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await request('get', `${URLS.DAPIL}?limit=${payload.limit}&skip=${payload.page}&id_kabupaten=${payload.id_kabupaten}`)
            return response.data.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)


export const fetchDapilByJenis = createAsyncThunk(
    'Dapil/fetchDapilByJenis',
    async (jenis, { rejectWithValue }) => {
        try {
            const response = await request('get', `${URLS.DAPIL}/jenis/${jenis}`)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const addDapil = createAsyncThunk(
    'Dapil/addDapil',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await request('post', URLS.DAPIL, payload)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const updateDapil = createAsyncThunk(
    'Dapil/updateDapil',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await request('patch', URLS.DAPIL, payload)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)
export const fetchOneDapil = createAsyncThunk(
    'Dapil/fetchOneDapil',
    async (id, { rejectWithValue }) => {
        try {
            const response = await request('get', `${URLS.DAPIL}/${id}`)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const deleteDapil = createAsyncThunk(
    'Dapil/deleteDapil',
    async (id, { rejectWithValue }) => {
        try {
            const response = await request('delete', `${URLS.DAPIL}/${id}`)
            return response.data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

const initialState = {
    loading: {
        query: false,
        mutation: false
    },
    filter: {
        q: ''
    },
    list: [],
    selected: {},
    selectedRows: []
}

const loadingReducer = (fieldName, status) => (state) => {
    state.loading[fieldName] = status
}

const startLoadingQuery = loadingReducer('query', true)
const stopLoadingQuery = loadingReducer('query', false)
const startLoadingMutation = loadingReducer('mutation', true)
const stopLoadingMutation = loadingReducer('mutation', false)

export const DapilSlice = createSlice({
    name: 'Dapil',
    initialState,
    reducers: {
        setAppliedSearchText: (state, action) => {
            state.filter.q = action.payload
        },
        setSelectedRows: (state, action) => {
            state.selectedRows = action.payload
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchAllDapil.pending, startLoadingQuery)
            .addCase(fetchAllDapil.fulfilled, (state, action) => {
                state.list = action.payload
                state.loading.query = false
            })
            .addCase(fetchAllDapil.rejected, stopLoadingQuery)
        builder
            .addCase(fetchOneDapil.pending, startLoadingQuery)
            .addCase(fetchOneDapil.rejected, stopLoadingQuery)
            .addCase(fetchOneDapil.fulfilled, (state, action) => {
                state.loading.query = false
                state.selected = action.payload
            })
        builder
            .addCase(updateDapil.pending, startLoadingQuery)
            .addCase(updateDapil.rejected, stopLoadingQuery)
            .addCase(updateDapil.fulfilled, (state, action) => {
                state.loading.query = false
                state.selected = action.payload
            })
        builder
            .addCase(fetchDapilByJenis.pending, startLoadingQuery)
            .addCase(fetchDapilByJenis.fulfilled, (state, action) => {
                state.list = action.payload
                state.loading.query = false
            })
            .addCase(fetchDapilByJenis.rejected, stopLoadingQuery)
        builder
            .addCase(deleteDapil.pending, startLoadingMutation)
            .addCase(deleteDapil.fulfilled, stopLoadingMutation)
            .addCase(deleteDapil.rejected, stopLoadingMutation)
    }
});


export const { setSelectedRows, setAppliedSearchText } = DapilSlice.actions;

export default DapilSlice.reducer;